import _isString from 'lodash/isString';
import _isFunction from 'lodash/isFunction';

/**
 * A map function for a strings
 * @param {String} original The string to map on
 * @param {Function} onEach The function to apply to each character of the string
 * @returns {string}
 */
const mapString = (original, onEach) => {
  if (!_isString(original)) {
    throw new TypeError(`\`original\` is not a string: ${original}`);
  }
  if (!_isFunction(onEach)) {
    throw new TypeError(`\`onEach\` is not a function: ${onEach}`);
  }
  return original.split('').map(onEach).join('');
};

// What index of the cleaned value to insert a string before
const insertions = { 0: '(', 3: ') ', 6: '-' };
// The maximum length WITHOUT insertions
const maxPrunedLength = 10;

/**
 * Strip all non-numeric characters out of a string
 * @param {string} value
 * @returns {string} The string as purely numegric
 */
const strip = (value = '') => {
  if (_isString(value)) {
    return value.replace(/\D/g, '');
  }
  return '';
};

/**
 * Get 10-digit-only value from a formatted phone number
 *
 * @param {string} value
 * @return {string}
 */
const clean = (value = '') => {
  return strip(value).slice(0, maxPrunedLength);
};

/**
   * Apply the insertions defined above
   * @param {string} value - The original value
   * @returns {string} The string with the insertions added
   */
export default (value = '') => {
  const digits = clean(value);
  if (digits) {
    return mapString(digits, (character, index) => {
      const insertion = insertions[index] || '';
      return insertion + character;
    });
  }
  return digits;
};

// /**
//    * Determine whether a given value is a valid phone number
//    * @param value
//    * @return {boolean}
//    */
// validate (value) {
//   const digits = strip(value);
//   return !!digits && digits.length === maxPrunedLength;
// },
